import React, { useRef, useState } from "react";
import "./Contact.css";
import useReveal from "./useReveal";
import ModelViewer from "./ModelViewer";
import { sendForm } from "@emailjs/browser";
import Toast from "./Toast";
import "./Toast.css";

export default function Contact() {
  const revealRef = useReveal();
  const formRef = useRef();
  const [sending, setSending] = useState(false);
  const [toast, setToast] = useState({
    visible: false,
    message: "",
    type: "success",
  });

  const showToast = (message, type = "success") => {
    setToast({ visible: true, message, type });
  };

  return (
    <section className="contact-cosmic reveal" id="contact" ref={revealRef}>
      <div className="dust-layer"></div>
      <div className="dust-layer2"></div>

      <h2 className="contact-title">reach me beyond the stars ✦</h2>
      <p className="contact-sub">
        let’s create something ethereal together — stories that drift between
        worlds and dreams.
      </p>

      <div className="contact-wrapper">
        {/* form left */}
        <form
          ref={formRef}
          className="contact-form"
          onSubmit={async (e) => {
            e.preventDefault();
            try {
              const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
              const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
              const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

              console.log("EmailJS config:", {
                serviceID: !!serviceID,
                templateID: !!templateID,
                publicKey: !!publicKey,
                source: 'env',
              });

              if (!serviceID || !templateID || !publicKey) {
                showToast(
                  "Email service not configured. See README to set up EmailJS.",
                  "error"
                );
                return;
              }

              setSending(true);
              try {
                const timeInput = formRef.current && formRef.current.elements && formRef.current.elements["time"];
                if (timeInput) timeInput.value = new Date().toLocaleString();
              } catch (e) {}

              const res = await sendForm(serviceID, templateID, formRef.current, publicKey);
              console.log("EmailJS response:", res);
              e.target.reset();
              showToast("Your message has been sent — I’ll find it soon ♡", "success");
            } catch (err) {
              console.error("Email send error:", err);
              showToast(
                "Sorry — something went wrong sending your message. Try again later.",
                "error"
              );
            } finally {
              setSending(false);
            }
          }}
        >
          <input type="hidden" name="to_email" value="aradhanajadeja81@gmail.com" />
          <input type="hidden" name="title" value="Contact Us - Portfolio" />
          <input type="hidden" name="time" />
          <input name="name" type="text" placeholder="your name" required />
          <input name="email" type="email" placeholder="your email" required />
          <textarea name="message" placeholder="your message" rows="5" required></textarea>
          <button type="submit" className="send-btn" disabled={sending}>
            {sending ? "sending..." : "send"}
          </button>
        </form>

        {/* 3d model right */}
        <div className="contact-model">
          <ModelViewer />
        </div>
      </div>

      
      <Toast
        visible={toast.visible}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ ...toast, visible: false })}
      />
    </section>
  );
}
